import './archive-search-screen.scss'

import { defineComponent, PropType } from 'vue';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { SortFilter } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { SearchHeader } from '@skinsoft/search/src/search-header';
import { ArchiveFeaturedList, TitleClickAction } from '@skinsoft/ui';
import { CreateArchiveModal } from './create-archive-modal';

declare const config
const ARCHIVE_SORTING_ENTITY_FIELDS: SortFilter[] = config.archivesSortingEntityFields
const OFFLINE_ARCHIVE_SORTING_ENTITY_FIELDS: SortFilter[] = config.offlineArchivesSortingEntityFields

export const ArchiveSearchScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSearchHeader: SearchHeader,
        sArchiveFeaturedList: ArchiveFeaturedList,
        sCreateArchiveModal: CreateArchiveModal,
    },
    props: {
        targetRouteName: {
            type: String,
        },
        creationTargetRouteName: {
            type: String,
        },
        canCreateArchive: {
            type: Boolean,
            default: true,
        },
        titleClickAction: {
            type: Object as PropType<TitleClickAction>
        },
        displayedButtons: {
            type: Array,
        },
    },
    template: require('./archive-search-screen.html'),
    data() {
        return {
            sortingEntityFields: [] as SortFilter[],
            loadingArchiveCreation: false,
            spinnerIcon: faCircleNotch,
        }
    },
    computed: {
        archiveCreatedPath(): string {
            return this.creationTargetRouteName ?? this.targetRouteName ?? ''
        },
    },
    mounted() {
        if(window.navigator.onLine) {
            this.sortingEntityFields = ARCHIVE_SORTING_ENTITY_FIELDS
        } else {
            this.sortingEntityFields = OFFLINE_ARCHIVE_SORTING_ENTITY_FIELDS
        }

        window.addEventListener('online', this.updateSortingFields)
        window.addEventListener('offline', this.updateSortingFields)
    },
    methods: {
        openCreateArchiveModal() {
            (this.$refs.createArchiveModal as InstanceType<typeof CreateArchiveModal>).open()
        },
        updateSortingFields() {
            if(window.navigator.onLine) {
                this.sortingEntityFields = ARCHIVE_SORTING_ENTITY_FIELDS
            } else {
                this.sortingEntityFields = OFFLINE_ARCHIVE_SORTING_ENTITY_FIELDS
            }
        },
    },
})
